import React from 'react';
import { withRouter } from 'react-router-dom';
import * as PropTypes from 'prop-types';
import {
  Card, Icon, Row, Typography,
} from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import routeLocations from '../../../../utility/route-locations';
import NoInspections from './NoInspections';
import moment from 'moment';

const { Text } = Typography;


function DashTableLatestInspections({ history, dashboardData }) {
  const intl = useIntl();

  const hasRecentInspections = dashboardData && dashboardData.recentInspections && dashboardData.recentInspections.length > 0;
  if (!hasRecentInspections) return <NoInspections />;

  return (
    <div>
      <Row type="flex" align="top" justify="center" style={{ maxHeight: 340, maxWidth: 455, overflowY: 'auto' }}>
        {
          (
            dashboardData.recentInspections.map(row => (
              <Card
                key={Math.random()}
                className="via-dashboard-card"
                style={{ cursor: 'pointer' }}
                onClick={() => history.push(`${routeLocations.inspection}/${row.inspectionCode}`)}
              >
                <div className="via-dashboard-card-content">
                  <Row type="flex" justify="space-between">
                    <Row>
                      <FormattedMessage
                        id="widgetLatestTitle"
                        values={{
                          ref: <b>{row.inspectionCode}</b>,
                          regNo: <Text style={{ fontSize: '12pt', fontWeight: '600', color: 'var(--component-primary-colour)' }}>{row.regNumber}</Text>,
                        }}
                      />
                    </Row>
                    <Row>
                      <Text type="secondary">{row.submittedLocalTime ? (`${moment.parseZone(moment(row.submittedLocalTime, moment.ISO_8601)).format('ddd DD MMM YYYY')}`) : null}</Text>
                    </Row>
                  </Row>
                  <Row type="flex" align="middle" justify="start">
                    {row.noChecklistFaults > 0 || row.noNewDamages > 0
                      ? (
                        <div style={{ width: '100%' }}>
                          <span style={{
                            display: row.noChecklistFaults < 1 ? 'none' : '', color: 'var(--via-dashboard-checklist-failure-text-colour)', fontSize: '10pt', marginRight: '0.5em',
                          }}
                          >
                            <Icon type="close-circle" />
                                      &nbsp;
                            <FormattedMessage
                              id="widgetLatestChecklist"
                              values={{
                                checkFail: <b>{row.noChecklistFaults}</b>,
                                endS: row.noChecklistFaults > 1 ? intl.formatMessage({ id: 'pluralLetter' }) : '',
                              }}
                            />
                          </span>
                          <span style={{ display: row.noNewDamages < 1 ? 'none' : '', color: 'var(--via-dashboard-new-damages-text-colour)', fontSize: '10pt' }}>
                            <Icon type="exclamation-circle" />
                                &nbsp;
                            <FormattedMessage
                              id="widgetLatestDamages"
                              values={{
                                damageNew: <b>{row.noNewDamages }</b>,
                                endS: row.noNewDamages > 1 ? intl.formatMessage({ id: 'pluralLetter' }) : '',
                              }}
                            />
                          </span>
                        </div>
                      )
                      : (
                        <Row style={{ fontSize: '10pt', color: 'var(--via-dashboard-all-ok-text-colour)' }}>
                          <Icon type="check-circle" />
                          &nbsp;
                          <FormattedMessage id="widgetLatestSuccess" />
                        </Row>
                      )}
                  </Row>
                </div>
              </Card>
            )))
        }
      </Row>
    </div>
  );
}

DashTableLatestInspections.propTypes = {
  dashboardData: PropTypes.oneOfType([PropTypes.object]),
  history: PropTypes.oneOfType([PropTypes.object]),
};

DashTableLatestInspections.defaultProps = {
  dashboardData: null,
  history: null,
};

export default withRouter(DashTableLatestInspections);
